import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "grid grid-cols-4 gap-6" }
const _hoisted_3 = { class: "font-normal text-gray-500" }
const _hoisted_4 = { class: "font-lora text-2xl font-medium text-gray-800" }

import { useRoute } from 'vue-router';

import { useCalculatorSummaryEstimated } from '../composables/useCalculatorSummaryEstimated';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationWidget',
  setup(__props) {

const route = useRoute();

const { rules } = useCalculatorSummaryEstimated(Number(route.params.calculatorId));

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "font-bold text-gray-900" }, "Podsumowanie kalkulacji", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rules), (rule) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rule.id,
          class: "space-y-2 rounded-[10px] bg-gray-100 p-6"
        }, [
          _createElementVNode("header", _hoisted_3, _toDisplayString(rule.name), 1),
          _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(rule.eval) + " " + _toDisplayString(rule.unit), 1)
          ])), [
            [
              _directive_tooltip,
              rule.expression,
              void 0,
              { top: true }
            ]
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})